const STATUS_REQUEST_TYPE = {
  PENDING_STATUS_REQUEST_TYPE: 'Pendiente',
  APPROVED_STATUS_REQUEST_TYPE: 'Aprobado',
  REJECTED_STATUS_REQUEST_TYPE: 'Rechazado',
  PAYED_STATUS_REQUEST_TYPE: 'Pagado',
  REVIEW_STATUS_REQUEST_TYPE: 'Revisión',
  REVIEWED_STATUS_REQUEST_TYPE: 'Revisada',
  AUTHORIZED_STATUS_REQUEST_TYPE: 'Autorizada',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const STATUS_REQUEST_TYPE_ENUM = Object.keys(STATUS_REQUEST_TYPE);

const PENDING_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[0];
const APPROVED_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[1];
const REJECTED_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[2];
const PAYED_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[3];
const REVIEW_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[4];
const REVIEWED_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[5];
const AUTHORIZED_STATUS_REQUEST_TYPE = STATUS_REQUEST_TYPE_ENUM[6];

export {
  STATUS_REQUEST_TYPE_ENUM,
  STATUS_REQUEST_TYPE,
  PENDING_STATUS_REQUEST_TYPE,
  APPROVED_STATUS_REQUEST_TYPE,
  REJECTED_STATUS_REQUEST_TYPE,
  PAYED_STATUS_REQUEST_TYPE,
  AUTHORIZED_STATUS_REQUEST_TYPE,
  REVIEW_STATUS_REQUEST_TYPE,
  REVIEWED_STATUS_REQUEST_TYPE,
};
